import LicenseTrial from '../../gd/license/license-trial';
import LicensePro from '../../gd/license/license-pro';
import LicenseProFlatRate from '../../gd/license/license-pro-flat-rate';
import LicenseFree from '../../gd/license/license-free';
import CompanySettings from "../../client-data/company/company-settings";
import LicenseProfessional2023 from "../../gd/license/license-professional-2023";
import LicenseBusiness2023 from "../../gd/license/license-business-2023";
import LicenseEnterprise2023 from "../../gd/license/license-enterprise-2023";
import ModelEntity from "../model-entity";
import {EntityType} from "../../gd/const/item";
import ModelProxy from "../model-proxy";
import {convertLetterToColorNumber} from "../../gd/convert/letter-to-color-number";
import CompanyPriorities from "../priority/priorities";
import {CompanyRole} from "../../gd/const/company-role";
import LicenseProto from "../../gd/license/license-proto";
import ProjectsCollection from "../../gd-model/tree/projects-collection";
import {BinaryWeek, DayOfWeekName, DaysOfWeek} from "../../gd/types/types";
import { CompanyAccessControl } from './access-control/access-control';
import DatetimeUtils from "../../gd/utils/datetime-utils"


export default class Company extends ModelEntity {

    public name                         : string
    public abbreviation                 : string
    public icon                         : string
    public color                        : number

    public role                         : number
    public priorities                   : CompanyPriorities
    public isAdmin                      : boolean
    public accountType                  : number    // License number
    public licenseUsers?                : number    // total number of users allowed for this company
    public config                       : any       // additional config ... suspend, login warning, etc
    public settings                     : CompanySettings
    public finance                      : number    // current finance module setting [0..3]
    public financeCurrency              : string
    public financeDefaultInternalCost   : number //'float',
    public financeDefaultExternalCost   : number //'float',
    public license!                     : LicenseProto // 'object', // company license
    public workWeek                     : BinaryWeek

    public projects?                    : ProjectsCollection // is filled in CompaniesCollection

    public dateCreated?                 : Moment

    constructor(data:any, useProxy = true) {
        super(data['id'], EntityType.COMPANY)

        this.name                       = data['name']
        this.icon                       = data['icon']
        this.role                       = _.get(data,'role', CompanyRole.GUEST) // hmmm gues is new... can it be empty ?

        this.abbreviation               = _.get(data, 'abbreviation')
        if (!this.abbreviation) this.abbreviation = gd.utils.initials(this.name,2)  // in _get default didnt work - why

        this.color                      = _.get(data, 'color')
        if (!this.color) this.color     = this.getColor()

        this.priorities                 = new CompanyPriorities()

        this.config                     = _.get(data,'config', {})

        this.isAdmin                    = _.get(data,'isAdmin', false)

        this.financeCurrency            = _.get(data, 'financeCurrency', 'us_dollar')

        this.settings                   = new CompanySettings(this.id, data.settings ? data.settings : {})

        this.finance                    = _.get(data,'finance', 0)
        this.financeDefaultInternalCost = _.get(data,'financeDefaultInternalCost', 0)
        this.financeDefaultExternalCost = _.get(data,'financeDefaultExternalCost', 0)

        // this is new
        this.workWeek                   = this.settings.workSchedule.workWeek
        this.dateCreated                = DatetimeUtils.dateToMoment(data.dateCreated)

        // License related
        this.accountType                = _.get(data, 'accountType', gd.const.company.license.FREE)
        this.licenseUsers               = _.get(data, 'licenseUsers', undefined)
        this.initLicense()

        return useProxy ? new Proxy(this, ModelProxy) : this;
    }

    get acl():CompanyAccessControl {
        return new CompanyAccessControl(this)
    }

    initLicense() {
        // init license
        switch (this.accountType) {

            case gd.const.company.license.ENTERPRISE:
                this.license = new LicenseEnterprise2023(this.licenseUsers || 25);
                break;
            case gd.const.company.license.PRO_2023: this.license = new LicenseProfessional2023(this.licenseUsers || 10); break;
            case gd.const.company.license.BUSINESS_2023: this.license = new LicenseBusiness2023(this.licenseUsers || 10); break;


            case gd.const.company.license.PROFESSIONAL:
                this.license = new LicensePro(this.accountType, 250, this.licenseUsers || 10); break;
            case gd.const.company.license.PROFESSIONAL_OLD:
                this.license = new LicensePro(this.accountType, 250, this.licenseUsers || 10); break;
            case gd.const.company.license.PRO_PAY_PER_USER:
                this.license = new LicensePro(this.accountType, 250, this.licenseUsers || 10); break;

            case gd.const.company.license.PRO_FLAT_RATE_10_USERS: this.license = new LicenseProFlatRate(this.accountType, 250, 10); break;
            case gd.const.company.license.PRO_FLAT_RATE_15_USERS: this.license = new LicenseProFlatRate(this.accountType, 250, 15); break;

            case gd.const.company.license.TRIAL_PRO: this.license = new LicenseTrial(this.accountType, 0); break;
            case gd.const.company.license.TRIAL_PRO_14: this.license = new LicenseTrial(this.accountType, 14); break;
            case gd.const.company.license.TRIAL_PRO_21: this.license = new LicenseTrial(this.accountType, 21); break;
            case gd.const.company.license.TRIAL_PRO_30: this.license = new LicenseTrial(this.accountType, 30); break;



            case gd.const.company.license.FREE_25:  this.license = new LicenseFree(this.accountType, 25); break;
            case gd.const.company.license.FREE_15:  this.license = new LicenseFree(this.accountType, 15); break;
            case gd.const.company.license.FREE:
                this.license = new LicenseFree(gd.const.company.license.FREE, 15); break;
            default:
                console.error("ERROR-LICENSE-1", this.accountType )
                this.license = new LicenseFree(gd.const.company.license.FREE, 15); break;

        }
    }

    get isPremium():boolean {
        return !!this.accountType && this.accountType>0 && this.accountType!==gd.const.company.license.FREE && this.accountType!==gd.const.company.license.FREE_15;
    }


    get isSuspended():boolean {
        if (_.get(this.config, 'accountSuspended')) {
            return true
        }

        return false
    }

    get accountSuspendedMessage() {
        return _.get(this.config, 'accountSuspended')
    }

    trackInternalCosts() {
        return this.finance===1 || this.finance===3
    }

    trackExternalCosts() {
        return this.finance===2 || this.finance===3
    }

    getColor() {
        const letter = gd.utils.initials(this.abbreviation,1).toLowerCase();
        return convertLetterToColorNumber(letter ? letter : 'a');
    }

    get url() {
        return 'o/'+this.id
    }



    // exportMenu = () => {
    //     return {
    //         id: this.id,
    //         name: this.name,
    //         icon: this.iconSmall,
    //         type: 7, // company menu type
    //         isOpen: false,
    //         url: this.url
    //     }
    // }

    // toJSON() {
    //     return {
    //         id      : this.id,
    //         name    : this.name
    //         // ... rest not implemented - not sure why we need it
    //         // had error in my work
    //     }
    // }


}



